import { takeEvery } from 'typed-redux-saga';
import { sendTextMsg } from "../actions";
import sendTextMsgHandler from "../sendMsgHandler/sendTextMsgHandler";

export default function* watchSendTextMsg() {
  yield* takeEvery(sendTextMsg, function* (action) {
    yield sendTextMsgHandler.sendMsg(action);
  });
}
